import React, { useEffect, useState } from "react"
import { formatAddress } from "../../utils"

import { approve, payProduct } from "./utils/paymentUtils"

import {
    ModalHeader,
    Modal,
    ModalBody,
    Button,
    Card,
    CardBody,
    CardText,
    CardTitle,
    Col,
    Form,
    FormGroup,
    Input,
    Row,
    Spinner,
    Table,
    Label,
    CardFooter
} from "reactstrap"

import BreadCrumb from "../../Components/BreadCrumb"
import { useWallet } from "../../libs/useMetaMaskWallet"
import { useToast } from "../../hooks/toast"
import Web3 from "web3"

import ConnectWallet from "../../Components/ConnectWallet"

const SingleUsePayment = require("../../abi/payments/SingleUsePayments.json")
const ERC20 = require("../../abi/FIDO.json")

const CONTRACTS = {
    fantom: {
        chainId: 250,
        contractAddress: "0x964bC4508e5db36b424677CE29a1f3368306378a",
        contractAbi: SingleUsePayment,
        args: { maxPriorityFeePerGas: "0xba43b74000" }
    }
}

const Payment = () => {
    const web3 = new Web3()

    const toast = useToast()

    const wallet = useWallet()
    const [processing, setProcessing] = useState(false)

    const [isLoading, setIsLoading] = useState(false)
    const [selectedNetwork, setSelectedNetwork] = useState(null)

    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)

    const [purchases, setPurchases] = useState([])
    const [receipts, setReceipts] = useState({})

    const [products, setProducts] = useState({})

    const [inputProduct, setInputProduct] = useState("")

    // const [selectedProduct, setSelectedProduct] = useState([])

    const [allowance, setAllowance] = useState(0)

    const handleForm = (e) => {
        const id = e.target.id

        switch (id) {
            case "product_input":
                setInputProduct(e.target.value)
                break

            default:
                break
        }
    }

    useEffect(() => {
        const loadAllowance = async () => {
            if (
                updateConnection() &&
                wallet.account &&
                selectedNetwork !== null &&
                Object.keys(products).length > 0 &&
                selectedNetwork in CONTRACTS
            ) {
                setIsLoading(true)

                try {
                    web3.setProvider(wallet.ethereum.provider)

                    let product = products[inputProduct]

                    let contract = new web3.eth.Contract(ERC20, product.paymentToken)

                    let allowed = await contract.methods.allowance(wallet.account, CONTRACTS[selectedNetwork]?.contractAddress).call()

                    setAllowance(allowed)
                } catch (error) {
                    console.log(error)
                } finally {
                    setIsLoading(false)
                }
            } else {
                setAllowance(0)
            }
        }

        loadAllowance()

        return () => {
            setAllowance(0)
        }
    }, [inputProduct])

    useEffect(() => {
        if (isConnectedToWallet) {
            switch (wallet.chainId) {
                // case 1:
                //     setSelectedNetwork("ethereum")
                //     break
                case 250:
                    setSelectedNetwork("fantom")
                    break

                default:
                    setSelectedNetwork(null)
                    break
            }
        }

        return () => {
            setSelectedNetwork(null)
        }
    }, [isConnectedToWallet, wallet])

    const updateConnection = () => {
        const x = wallet.status === "connected"
        setIsConnectedToWallet(x)
        return x
    }

    const setMessage = async (type, message) => {
        switch (type) {
            case "success":
                toast.addSuccess(message)
                break
            case "error":
                toast.addError(message)
                break
            case "info":
                toast.addInfo(message)
                break
            default:
                break
        }
    }

    const setAllowed = (amount) => {
        setAllowance(amount)
    }

    const handleApprove = async () => {
        web3.setProvider(wallet.ethereum.provider)

        await approve(web3, ERC20, CONTRACTS[selectedNetwork], wallet.account, products[inputProduct], setProcessing, setMessage, setAllowed)
    }

    const handlePayProduct = async () => {
        web3.setProvider(wallet.ethereum.provider)

        await payProduct(web3, ERC20, CONTRACTS[selectedNetwork], wallet.account, products[inputProduct], setProcessing, setMessage)
    }

    useEffect(() => {
        const loadPurchases = async () => {
            if (updateConnection() && wallet.account && selectedNetwork !== null && selectedNetwork in CONTRACTS) {
                setIsLoading(true)

                try {
                    web3.setProvider(wallet.ethereum.provider)
                    let contract = new web3.eth.Contract(CONTRACTS[selectedNetwork]?.contractAbi, CONTRACTS[selectedNetwork]?.contractAddress)
                    let purchaseList = await contract.methods.getPurchased(wallet.account).call()

                    let receipts = {}
                    for (let p = 0; p < purchaseList.length; p++) {
                        let r = {}
                        let receipt = await contract.methods.getReceiptInfo(purchaseList[p].receiptId).call()
                        r[purchaseList[p].receiptId] = {
                            productId: receipt.productId,
                            paidAt: receipt.PaidAt,
                            paidAmount: receipt.paidAmount,
                            hasUsed: receipt.hasUsed,
                            hashOfUse: receipt.hashOfUse
                        }
                        receipts[purchaseList[p].receiptId] = r
                    }

                    setPurchases(purchaseList)
                    setReceipts(receipts)
                } catch (error) {
                    console.log(error)
                } finally {
                    setIsLoading(false)
                }
            } else {
                setPurchases([])
            }
        }

        loadPurchases()

        return () => {
            //
        }
    }, [selectedNetwork, wallet])

    useEffect(() => {
        const loadData = async () => {
            if (updateConnection() && wallet.account && selectedNetwork !== null && selectedNetwork in CONTRACTS) {
                setIsLoading(true)

                try {
                    web3.setProvider(wallet.ethereum.provider)
                    let contract = new web3.eth.Contract(CONTRACTS[selectedNetwork]?.contractAbi, CONTRACTS[selectedNetwork]?.contractAddress)
                    let productsList = await contract.methods.getProducts().call()

                    let products = []
                    let prodObj = {}
                    for (let p = 0; p < productsList.length; p++) {
                        let product = await contract.methods.getProduct(productsList[p]).call()

                        let pTokenContract = new web3.eth.Contract(ERC20, product[0].paymentToken)
                        let pName = await pTokenContract.methods.name().call()
                        let pSymbol = await pTokenContract.methods.symbol().call()

                        products.push(product[0])
                        let prod = {}
                        prod = {
                            productId: product[0].productId,
                            paymentToken: product[0].paymentToken,
                            paymentName: pName,
                            paymentSymbol: pSymbol,
                            price: product[0].price,
                            openForSale: product[0].openForSale
                        }

                        prodObj[product[0].productId.toLowerCase()] = prod
                    }

                    setInputProduct(productsList[0].toLowerCase())
                    setProducts(prodObj)
                } catch (error) {
                    console.log(error)
                } finally {
                    setIsLoading(false)
                }
            } else {
                setProducts({})
            }
        }

        loadData()
        return () => {
            setProducts({})
        }
    }, [selectedNetwork, wallet])

    //
    return (
        <React.Fragment>
            <div>
                <BreadCrumb current="Idexo Payments" />
                {!isConnectedToWallet ? (
                    <ConnectWallet wallet={wallet} onChange={updateConnection} />
                ) : isLoading ? (
                    <Modal isOpen={isLoading} centered={true}>
                        <ModalBody className="text-center h3">Loading...</ModalBody>

                        <ModalBody className="text-center">
                            <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="dark" />
                        </ModalBody>
                    </Modal>
                ) : (
                    <div>
                        <Row>
                            <Col sm={{ offset: 1, size: 10 }}>
                                <Card>
                                    <CardBody>
                                        <Form>
                                            <Row>
                                                <FormGroup>
                                                    <label for="selectProduct">Product</label>
                                                    <Input
                                                        id="product_input"
                                                        name="product"
                                                        type="select"
                                                        value={inputProduct}
                                                        onChange={handleForm}
                                                        className="mb-3"
                                                        disabled={Object.keys(products).length === 0}
                                                    >
                                                        {Object.keys(products).map((key) => {
                                                            let val = products[key]?.productId?.toLowerCase().replace(" ", "_")
                                                            return (
                                                                <option key={val} value={val}>
                                                                    {products[key]?.productId}
                                                                </option>
                                                            )
                                                        })}
                                                    </Input>
                                                </FormGroup>
                                            </Row>
                                            {Object.keys(products).length !== 0 ? (
                                                <>
                                                    <CardText className="h4">
                                                        Payment Token: {products[inputProduct]?.paymentName}
                                                        {" - "}
                                                        {formatAddress(products[inputProduct]?.paymentToken)}
                                                    </CardText>
                                                    <CardText className="h4">
                                                        Price: {web3.utils.fromWei(products[inputProduct].price.toString(), "ether")}{" "}
                                                        {products[inputProduct]?.paymentSymbol}
                                                    </CardText>
                                                    <CardText className="h4">
                                                        Open for sale: {products[inputProduct]?.openForSale ? "Yes" : "No"}
                                                    </CardText>
                                                </>
                                            ) : null}
                                        </Form>
                                    </CardBody>
                                    <CardFooter>
                                        <Button
                                            className="btn submit-btn w-100 blue-btn text-uppercase"
                                            disabled={processing || Object.keys(products).length === 0 || !products[inputProduct]?.openForSale}
                                            onClick={
                                                allowance >= Number(products[inputProduct]?.price) ? () => handlePayProduct() : () => handleApprove()
                                            }
                                        >
                                            {!processing
                                                ? !products[inputProduct]?.openForSale
                                                    ? "Not for sale"
                                                    : allowance >= Number(products[inputProduct]?.price)
                                                      ? "Purchase"
                                                      : "Approve"
                                                : "Processing... "}
                                            {processing ? <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" /> : null}
                                        </Button>
                                    </CardFooter>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={{ offset: 1, size: 10 }}>
                                <Card>
                                    <CardBody>
                                        {purchases.length > 0 ? (
                                            purchases.map((purchase) => {
                                                return (
                                                    <CardText key={purchase.receiptId}>
                                                        Receipt Id: {purchase.receiptId} / Product Id: {purchase.productId} / Paid:{" "}
                                                        {web3.utils.fromWei(purchase.amount.toString(), "ether")} / Used:{" "}
                                                        {receipts[purchase.receiptId]?.hasUsed ? "Used" : "Not used"}
                                                    </CardText>
                                                )
                                            })
                                        ) : (
                                            <CardText>No purchases found</CardText>
                                        )}
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}

export default Payment
